module.exports = __webpack_public_path__ + "static/media/flash-deal-details-ils.c5dc8e0f.png";